import {push} from 'notivue';

export function notifyError(message) {

    console.log(message)
    if (typeof message === 'string') {
        push.error({
            title: 'Erro!',
            message,
            duration: 5000
        })
    } else if(message.status) {
        if (message.status === 422) {
            const errorData = message.data?.errors || message.data;
            const keys = Object.keys(errorData);
            let data = '';

            keys.forEach(key => {
                const errValue = errorData[key];
                if (Array.isArray(errValue)) {
                    errValue.forEach(err => {
                        data += `${err}\n`;
                    });
                } else if (typeof errValue === 'string') {
                    data += `${errValue}\n`;
                }
            });

            push.error({
                title: 'Erro!',
                message: data.trim() || 'Erro de validação.',
                duration: 5000
            });
        } 
        else if (message.status >= 500) {
            push.error({
                title: 'Erro!',
                message: message.data?.message || 'Erro interno no servidor.',
                duration: 5000
            });
        } 
        else {
            push.error({
                title: 'Erro!',
                message: message.data?.message || 'Ocorreu um erro inesperado.',
                duration: 5000
            });
        }
    }
}

export function notifySuccess(message) {
    push.success({
        title: 'Sucesso!',
        message,
        duration: 5000
    })
}

export function getMessageError(data) {
    const keys = Object.keys(data);
    if (keys.length > 0) {
        notifyError(data[keys[0]][0]);
    }
}